import { render, staticRenderFns } from "./PaymentHistory.vue?vue&type=template&id=30c560e0&scoped=true&"
import script from "./PaymentHistory.vue?vue&type=script&lang=ts&"
export * from "./PaymentHistory.vue?vue&type=script&lang=ts&"
import style0 from "./PaymentHistory.vue?vue&type=style&index=0&id=30c560e0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30c560e0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1771009219/src/capas-web-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('30c560e0')) {
      api.createRecord('30c560e0', component.options)
    } else {
      api.reload('30c560e0', component.options)
    }
    module.hot.accept("./PaymentHistory.vue?vue&type=template&id=30c560e0&scoped=true&", function () {
      api.rerender('30c560e0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Brand/PaymentHistory.vue"
export default component.exports